import Immutable from 'seamless-immutable';
import _ from 'lodash';
import SharingModel from './sharing-model';

const defaultSharingConfig = {
  default: {
    context:   'campaign',
    action:    'share',
    network:   'default',
    isDefault: true,
    // this is the only writable attribute at this level
    enabled:   false,
    // stores the sharing config data that defines what will be shared in the Experience
    data:      [
      {
        link: 'ctx:smarturl',
      },
    ],
  },
  facebookShare: {
    context:   'campaign',
    action:    'share',
    network:   'facebook',
    isDefault: false,
    enabled:   false, // this is the only writable attribute at this level
    data:      [{}], // stores the sharing config data that defines what will be shared in the Experience
  },
  twitterShare: {
    context:   'campaign',
    action:    'share',
    network:   'twitter',
    isDefault: false,
    enabled:   false, // this is the only writable attribute at this level
    data:      [{}], // stores the sharing config data that defines what will be shared in the Experience
  },
  pinterestShare: {
    context:   'campaign',
    action:    'share',
    network:   'pinterest',
    isDefault: false,
    enabled:   false, // this is the only writable attribute at this level
    data:      [{}], // stores the sharing config data that defines what will be shared in the Experience
  },
  facebookConfirmation: {
    context:   'confirmation',
    action:    'share',
    network:   'facebook',
    isDefault: false,
    enabled:   false, // this is the only writable attribute at this level
    data:      [{}], // stores the sharing config data that defines what will be shared in the Experience
  },
};

function deserialize(sharingConfig = defaultSharingConfig) {
  return Immutable(_.reduce(sharingConfig, SharingModel.deserialize, {}));
}

function serialize(sharingConfig) {
  return _.reduce(sharingConfig, SharingModel.serialize, {});
}

export default {
  deserialize,
  serialize,
};
